import { Calendar, Clock } from "lucide-react";
import moment from "moment";
import React from 'react';
import { useTranslation } from 'react-i18next'; // ADD THIS IMPORT
import { SectionTitle } from "./SectionTitle";

interface DateTimeSectionProps {
  selectedDateTime: Date | null;
  selectedTime: string | null;
  timeZone: string;
  colors?: any;
}

export const DateTimeSection: React.FC<DateTimeSectionProps> = ({
  selectedDateTime,
  selectedTime,
  timeZone,
  colors = {}
}) => {
  const { t } = useTranslation(); // ADD THIS LINE

  const defaultColors = {
    cardBackground: "#000000F2",
    cardBorder: "#DDB88919",
    cardShadow: "rgba(221,184,137,0.07)",
    cardShadowSelected: "rgba(221,184,137,0.1)",
    titleText: "#DDB889",
    subtitleText: "#DDB889CC",
    infoText: "#DDB88999",
    iconColor: "#DDB889"
  };

  // Merge default colors with provided colors
  const mergedColors = { ...defaultColors, ...colors };

  // Create style objects from the colors
  const cardStyle = {
    backgroundColor: mergedColors.cardBackground,
    borderColor: mergedColors.cardBorder,
    boxShadow: `0 0 15px ${mergedColors.cardShadow}`
  };

  const cardHoverStyle = {
    boxShadow: `0 0 20px ${mergedColors.cardShadowSelected}`
  };

  const iconStyle = {
    color: mergedColors.iconColor
  };

  const textStyle = {
    color: mergedColors.subtitleText
  };

  const textHoverStyle = {
    color: mergedColors.titleText
  };

  const emptyTextStyle = {
    color: `${mergedColors.infoText}`
  };

  const emptyTextHoverStyle = {
    color: `${mergedColors.subtitleText}`
  };

  return (
    <div
      className="lp-backdrop-blur-sm lp-border lp-rounded-2xl lp-p-6 lp-transition-all lp-duration-700 hover:lp-shadow-[0_0_20px_rgba(221,184,137,0.1)]"
      style={cardStyle}
    >
      <SectionTitle
        icon={Calendar}
        title={t('dateTimeSection.title')} /* CHANGED: "Date & Time" */
        colors={mergedColors}
      />
      {selectedDateTime ? (
        <div className="lp-space-y-3">
          <p className="lp-flex lp-items-center lp-group">
            <Calendar
              size={20}
              className="lp-mr-3 lp-shrink-0 lp-transition-transform lp-duration-200 group-hover:lp-scale-110"
              style={iconStyle}
            />
            <span
              className="lp-transition-colors lp-duration-200 group-hover:lp-text-[#DDB889]"
              style={textStyle}
            >
              {moment(selectedDateTime).tz(timeZone).format('dddd, MMMM D, YYYY')}
            </span>
          </p>
          <p className="lp-flex lp-items-center lp-group">
            <Clock
              size={20}
              className="lp-mr-3 lp-shrink-0 lp-transition-transform lp-duration-200 group-hover:lp-scale-110"
              style={iconStyle}
            />
            <span
              className="lp-transition-colors lp-duration-200 group-hover:lp-text-[#DDB889]"
              style={textStyle}
            >
              {selectedTime}
            </span>
          </p>
        </div>
      ) : (
        <p
          className="lp-transition-colors lp-duration-200 hover:lp-text-[#DDB889]/70"
          style={emptyTextStyle}
        >
          {t('dateTimeSection.notSelected')} {/* CHANGED: "Not selected" */}
        </p>
      )}
    </div>
  );
};
